module.exports = __webpack_public_path__ + "img/souvenirs-thermos-01.7193f301.png";